<script>
  import { Line, mixins } from 'vue-chartjs'

  const {reactiveProp} = mixins
  export default {
    extends: Line,
    mixins: [reactiveProp],
    name: "TsLineChart",
    props: ['options'],
    mounted () {
      this.$el.classList.add('ts-line-chart')
      this.renderChart(this.chartData, this.options)
    },
  }
</script>
<style scoped lang="scss">
  ::v-deep{
    &.ts-line-chart{
      position:relative;
      width:100%;
      height:100%;
    }
  }
</style>